import React from 'react'
// import { Container } from './unstatedNextPro'
// Business
import System from './system'

const Store: React.FC = ({ children }) => {
  console.log(`global contexts have been re-rendered at: ${Date.now()}`)

  // return <ComposedStore>{children}</ComposedStore>
  return <System.Provider>{children}</System.Provider>
}

export default Store
